import React from 'react';
import { CONTENT_TYPES } from '../../../core/constants';
import { EMAG } from '../../Pages';

export default {
  path: EMAG.pageURL,
  async action() {
    const { default: CommonManager } =
      await import('../common/ContentManagerView/CommonManager');
    return (
      <CommonManager
        key={'list'}
        contentType={CONTENT_TYPES.EMAG}
        page={EMAG}
      />
    );
  },
};
